// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Open+Sans:wght@300&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
  font-family: "Open Sans", sans-serif;
  font-weight: 500;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: white;
  padding: 1vh 10vh; 
  padding-left: 12.5vh; 
}

.brand {
  color: black;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  
}

.brand h1 {
  margin: 0;
  letter-spacing: -0.25vh; 
  word-spacing: -0.25vh; 
  margin-bottom: -0.5vh; 
}

.brand p {
  color: black;
  margin: 0;
  margin-top: -0.5vh;
}

.brand img {
  width: 35%;
}

.orange-text {
  color: orange;
}

.options {
  display: flex;
}

.option {
  margin-right: 4.5vh; 
  cursor: pointer;
  position: relative;
  text-decoration: none;
  color: black;
}

.option:hover,
.option.orange-text {
  color: #c44e00;
}

.option:hover::after,
.option.orange-text::after {
  content: '';
  position: absolute;
  width: 100%;
  height: 0.2vh;
  background-color: orange;
  bottom: 0;
  left: 0;
}


.mobile-menu-icon {
  display: none;
  cursor: pointer;
}

.bar {
  width: 25px;
  height: 2px;
  background-color: black;
  margin: 5px 0;
}


@media (max-width: 768px) {
  .navbar {
    align-items: flex-end;
    padding-inline: 5%;
  }
  
  .options {
    display: none;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    
  }
  .option {
    margin-bottom: 2vh;
    font-size: xx-large; 
    color:white;
    margin-right: 0;
  }

  .mobile-menu-icon {
    display: flex;
    flex-direction: column;
    margin-bottom: 1.5%;
  }

  .mobile-options {
    background-color: #11224E;
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
    margin-top: 14.2%;
    overflow-y: auto;
    
  }
  

  .brand img {
    width: 50%;
  }


  
}
`, "",{"version":3,"sources":["webpack://./src/components/CustomNavbar.css"],"names":[],"mappings":"AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;;AAEzB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;AACd;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,wBAAwB;EACxB,SAAS;EACT,OAAO;AACT;;;AAGA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,aAAa;AACf;;;AAGA;EACE;IACE,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;;EAEb;EACA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,aAAa;IACb,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,MAAM;IACN,OAAO;IACP,aAAa;IACb,iBAAiB;IACjB,gBAAgB;;EAElB;;;EAGA;IACE,UAAU;EACZ;;;;AAIF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@300&display=swap');\r\n\r\n.navbar {\r\n  font-family: \"Open Sans\", sans-serif;\r\n  font-weight: 500;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  background-color: white;\r\n  padding: 1vh 10vh; \r\n  padding-left: 12.5vh; \r\n}\r\n\r\n.brand {\r\n  color: black;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  \r\n}\r\n\r\n.brand h1 {\r\n  margin: 0;\r\n  letter-spacing: -0.25vh; \r\n  word-spacing: -0.25vh; \r\n  margin-bottom: -0.5vh; \r\n}\r\n\r\n.brand p {\r\n  color: black;\r\n  margin: 0;\r\n  margin-top: -0.5vh;\r\n}\r\n\r\n.brand img {\r\n  width: 35%;\r\n}\r\n\r\n.orange-text {\r\n  color: orange;\r\n}\r\n\r\n.options {\r\n  display: flex;\r\n}\r\n\r\n.option {\r\n  margin-right: 4.5vh; \r\n  cursor: pointer;\r\n  position: relative;\r\n  text-decoration: none;\r\n  color: black;\r\n}\r\n\r\n.option:hover,\r\n.option.orange-text {\r\n  color: #c44e00;\r\n}\r\n\r\n.option:hover::after,\r\n.option.orange-text::after {\r\n  content: '';\r\n  position: absolute;\r\n  width: 100%;\r\n  height: 0.2vh;\r\n  background-color: orange;\r\n  bottom: 0;\r\n  left: 0;\r\n}\r\n\r\n\r\n.mobile-menu-icon {\r\n  display: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.bar {\r\n  width: 25px;\r\n  height: 2px;\r\n  background-color: black;\r\n  margin: 5px 0;\r\n}\r\n\r\n\r\n@media (max-width: 768px) {\r\n  .navbar {\r\n    align-items: flex-end;\r\n    padding-inline: 5%;\r\n  }\r\n  \r\n  .options {\r\n    display: none;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    width: 100%;\r\n    \r\n  }\r\n  .option {\r\n    margin-bottom: 2vh;\r\n    font-size: xx-large; \r\n    color:white;\r\n    margin-right: 0;\r\n  }\r\n\r\n  .mobile-menu-icon {\r\n    display: flex;\r\n    flex-direction: column;\r\n    margin-bottom: 1.5%;\r\n  }\r\n\r\n  .mobile-options {\r\n    background-color: #11224E;\r\n    display: flex;\r\n    width: 100%;\r\n    height: 100%;\r\n    justify-content: center;\r\n    align-items: center;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    z-index: 1000;\r\n    margin-top: 14.2%;\r\n    overflow-y: auto;\r\n    \r\n  }\r\n  \r\n\r\n  .brand img {\r\n    width: 50%;\r\n  }\r\n\r\n\r\n  \r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
